/**
 * LanguageSwitcher - Component to display current language
 */

import { Globe } from 'lucide-react'
import { Button } from '../primitives/button'
import { useTranslation } from '@/core'

export function LanguageSwitcher() {
  const { locale } = useTranslation()

  return (
    <Button
      variant="ghost"
      size="sm"
      className="flex items-center gap-2 cursor-default"
      title={locale === 'it' ? 'Italiano' : 'English'}
    >
      <Globe className="h-4 w-4" />
      <span className="font-semibold uppercase">{locale}</span>
    </Button>
  )
}
